export function downloadDataUri(dataUri: string, filename: string) {
  const anchor = document.createElement("a")
  anchor.href = dataUri
  anchor.download = filename

  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  downloadDataUri(url, filename)
  URL.revokeObjectURL(url)
}
